import instance from "./ApiConfig";
// import {
//   setLoadingFalse,
//   setLoadingTrue,
// } from "../../global/config/Action/loadingActions";
import store from "../../global/config/store";
import { hideLoading, showLoading } from "../../global/config/Reducer/loadingSlice";
export const baseApiCall = async (config: any) => {
  // store.dispatch(setLoadingTrue());
  // store.dispatch(showLoading())
  if (!config?.skipLoader) {
    store.dispatch(showLoading());
  }
  const fullResponse = config.fullResponse; // NEW FLAG
  delete config.fullResponse;

  try {
    const response = await instance(config);

    if (response?.status >= 200 && response?.status < 300) {
      // store.dispatch(setLoadingFalse());
      return fullResponse ? response : response?.data;
    } else {
      // store.dispatch(setLoadingFalse());
      throw new Error(`Unexpected status code: ${response?.status}`);
    }
  } catch (e: any) {
    console.log('API error', e);

    if (e?.response?.status === 401) {
      setTimeout(() => {
        localStorage.clear();
        window.location.href = "/login";
        return;
      }, 1000);
    }
    const errorMessage = e?.response?.data?.message || "An error occurred while making the request.";
    // store.dispatch(setLoadingFalse());
    console.log("errorMessage errorMessage", errorMessage)
    // throw new Error(errorMessage);
    throw errorMessage

  }
  finally {
    store.dispatch(hideLoading())
  }
};
